import { createContext, Dispatch } from 'react';
import { Events, initialState, State } from './useSetupSubdomainModalReducer';

export const SetupSubdomainModalContext = createContext<State & { open: () => void; dispatch: Dispatch<Events> }>({
  open: () => {},
  dispatch: () => {},
  ...initialState,
});
